import React, { useState, useEffect, useRef } from 'react';
import { X, Download, Printer, Edit } from 'lucide-react';
import apiService from '../config';
import { useSignature } from '../DigitalSignature/UseSignatue';
import SignaturePad from '../DigitalSignature/SignaturePad';

const Parishtisht6Notice = () => {
  const [isLoading, setIsLoading] = useState(false);
  const [landholdingData, setLandholdingData] = useState([]);
  const [fetching, setFetching] = useState(true);
  const [InchargeAddress, setInchargeAddress] = useState("");
  const [currentProjectId, setCurrentProjectId] = useState(null);
  const [currentProposalId, setCurrentProposalId] = useState(null);
  const [proposalNo, setProposalNo] = useState('');
  const [projectName, setProjectName] = useState('');
  const [previewUrl, setPreviewUrl] = useState(null);

  const [regionalInchargeName, setRegionalInchargeName] = useState("");
  const [regionalInchargeDesignation, setRegionalInchargeDesignation] = useState("");
  const [InchargeName, setInchargeName] = useState("");
  const [InchargeDesignation, setInchargeDesignation] = useState("");
  const [setIsSignAvailable] = useState(false);

  const today = new Date();
  const formattedDate = `${String(today.getDate()).padStart(2, '0')}/${String(today.getMonth() + 1).padStart(2, '0')}/${today.getFullYear()}`;

  const documentRef = useRef(null);
  const [showSignaturePad, setShowSignaturePad] = useState(false);
  const [pdfForSigning, setPdfForSigning] = useState(null);
  const [isViewerOpen, setIsViewerOpen] = useState(false);
  const [viewerFile, setViewerFile] = useState(null);

  const [isEditingParishisht6Header, setIsEditingParishisht6Header] = useState(false);
  const [parishisht6Header, setParishisht6Header] = useState("");
  const [parishisht6HeaderSaving, setParishisht6HeaderSaving] = useState(false);

  const {
    uploadStatus,
    selectedSignDocument,
    resetSignatureState,
    signDocument
  } = useSignature();

  const getProposalId = () => {
    return localStorage.getItem('currentProposalId') || currentProposalId;
  };

  const fetchLandholdings = async () => {
    try {
      setFetching(true);
      setIsLoading(true);

      const selectedProject = JSON.parse(localStorage.getItem('selectedProject') || '{}');
      const projectIdFromStorage = selectedProject?.id || selectedProject?.project_id;
      const proposalId = localStorage.getItem('currentProposalId') || currentProposalId;

      if (!projectIdFromStorage || !proposalId) {
        console.warn('Missing projectId or proposalId for fetchLandholdings');
        setFetching(false);
        setIsLoading(false);
        return;
      }

      const result = await apiService.getLandHolding(projectIdFromStorage, { proposalId });

      if (result?.status === 200 && Array.isArray(result.data)) {
        setLandholdingData(result.data);
      } else {
        console.warn('No landholding data found:', result);
      }

      if (result.proposalData && result.proposalData.length > 0) {
        const proposal = result.proposalData[0];
        setProposalNo(proposal.acquisition_proposal_no || '');
        setProjectName(proposal.project_name || '');
        setInchargeAddress(proposal.acquisition_incharge_address || '');

        setParishisht6Header(
          proposal?.parishisht6_header || proposal?.acquisition_proposal_no ||
          "प्रकल्पाच्या आखणीमध्ये समाविष्ट जमिनीच्या चतु:सिमा दर्शविणारा तक्ता"
        );
      }
    } catch (err) {
      console.error('Error fetching landholdings:', err);
    } finally {
      setFetching(false);
      setIsLoading(false);
    }
  };

  useEffect(() => {
    const getProjectInfo = () => {
      const currentProjectData = localStorage.getItem('currentProjectData');
      if (currentProjectData) {
        try {
          const projectData = JSON.parse(currentProjectData);
          return { id: projectData.project_id || projectData.id };
        } catch (e) { console.error(e); }
      }
      const selectedProject = localStorage.getItem('selectedProject');
      if (selectedProject) {
        try {
          const project = JSON.parse(selectedProject);
          return { id: project.project_id || project.id };
        } catch (e) { console.error(e); }
      }
      return { id: null };
    };

    const storedProposal = JSON.parse(localStorage.getItem('selectedProposal') || '{}');
    if (storedProposal?.acquisition_regional_incharge_name) setRegionalInchargeName(storedProposal.acquisition_regional_incharge_name);
    if (storedProposal?.acquisition_regional_incharge_designation) setRegionalInchargeDesignation(storedProposal.acquisition_regional_incharge_designation);
    if (storedProposal?.acquisition_incharge_designation) setInchargeDesignation(storedProposal.acquisition_incharge_designation);
    if (storedProposal?.acquisition_incharge_name) setInchargeName(storedProposal.acquisition_incharge_name);

    setCurrentProjectId(getProjectInfo().id);
  }, []);

  useEffect(() => {
    const loadProposalData = async () => {
      try {
        const userData = JSON.parse(localStorage.getItem("userData"));
        const project = JSON.parse(localStorage.getItem("selectedProject"));
        const projectId = project?.id || project?.project_id;
        const proposalId = userData?.default_proposal || userData?.proposal_id || localStorage.getItem('currentProposalId');

        if (projectId && proposalId) {
          const result = await apiService.getProposalById(projectId, proposalId);
          if (result && result.status === 200) {
            const proposal = Array.isArray(result.data) ? result.data[0] : result.data;
            setRegionalInchargeName(proposal?.acquisition_regional_incharge_name || "");
            setRegionalInchargeDesignation(proposal?.acquisition_regional_incharge_designation || "");
            setInchargeName(proposal?.acquisition_incharge_name || "");
            setInchargeDesignation(proposal?.acquisition_incharge_designation || "");
            setInchargeAddress(proposal?.acquisition_incharge_address || "");
          }
        }
      } catch (error) {
        console.error("Error loading proposal data:", error);
      }
    };

    loadProposalData();
  }, []);

  useEffect(() => {
    if (!selectedSignDocument) return;

    const postSignedPdf = async () => {
      try {
        setIsLoading(true);
        const selectedProject = JSON.parse(localStorage.getItem("selectedProject") || "{}");
        const projectId = selectedProject?.id || selectedProject?.project_id;
        const proposalId = localStorage.getItem("currentProposalId");

        if (!projectId || !proposalId) return;

        await apiService.postAddSignaturePDF(projectId, proposalId, "parishisht6", selectedSignDocument);
        const sectionRes = await apiService.getSectionFile(projectId, proposalId, "parishisht6");

        if (sectionRes?.isSignAvailable && sectionRes.data?.[0]?.file_path) {
          setPreviewUrl(sectionRes.data[0].file_path);
          setIsSignAvailable(true);
        }
      } catch (err) {
        console.error("Signed PDF upload error:", err);
      } finally {
        setIsLoading(false);
        resetSignatureState();
      }
    };
    postSignedPdf();
  }, [selectedSignDocument, resetSignatureState, setIsSignAvailable]);

  useEffect(() => {
    const getProposalInfo = () => {
      const currentProposal = JSON.parse(localStorage.getItem('userData') || '{}');
      if (currentProposal) {
        try {
          return {
            proposalId: currentProposal?.data?.default_proposal || currentProposal?.data?.proposal_id || currentProposal?.default_proposal || currentProposal?.proposal_id || null
          };
        } catch (e) { console.error(e); }
      }
      return { proposalId: null };
    };

    setCurrentProposalId(getProposalInfo().proposalId);
  }, []);

  useEffect(() => {
    const init = async () => {
      if (!currentProjectId || !currentProposalId) return;
      setFetching(true);
      try {
        await apiService.getSectionFile(currentProjectId, currentProposalId, 'parishisht6');
        await fetchLandholdings();
      } catch (e) {
        console.error('Error during section pre-check:', e);
        await fetchLandholdings();
      } finally {
        setFetching(false);
      }
    };
    init();
  }, [currentProjectId, currentProposalId]);

  const handleParishisht6HeaderSave = async () => {
    try {
      const proposalId = getProposalId();
      if (!proposalId) return alert("Proposal ID not found");

      setParishisht6HeaderSaving(true);
      const formDataToSend = new FormData();
      formDataToSend.append("parishisht6_header", parishisht6Header || "");

      const response = await apiService.patch(`/patchUpdateProposal?proposalId=${proposalId}`, formDataToSend);
      if (response?.status === 200 || response?.status === 201) {
        alert("परिशिष्ट-6 Header updated successfully!");
        setIsEditingParishisht6Header(false);
      } else {
        alert("Failed to update परिशिष्ट-6 Header");
      }
    } catch (error) {
      console.error("Error updating परिशिष्ट-6 header:", error);
      alert("Error while updating परिशिष्ट-6 Header");
    } finally {
      setParishisht6HeaderSaving(false);
    }
  };

  // ------------------------------------------------------------------
  // DATA GROUPING BY VILLAGE
  // ------------------------------------------------------------------
  const surveyTypeGroup = ["सर्व्हे क्रमांक", "गट क्रमांक", "प्लॉट क्रमांक"];

  const groupedByVillage = landholdingData.reduce((acc, item) => {
    const village = item.village_name || item.VillageName || 'Unknown';
    if (!acc[village]) {
      acc[village] = [];
    }
    acc[village].push(item);
    return acc;
  }, {});


  const handlePrint = () => {
    const printContent = documentRef.current?.innerHTML;
    if (!printContent) return alert("No content available to print.");

    const win = window.open("", "", "height=900,width=1200");
    win.document.write(`
      <html>
      <head>
        <title>परिशिष्ट-6</title>
        <style>
          @page {
            size: A4 portrait;
            margin-top: 0.19in;
            margin-bottom: 0.25in;
            margin-left: 0.81in;
            margin-right: 0.5in;
          }
          body {
            font-family: 'DVOT-Surekh', 'Mangal', 'Arial', sans-serif;
            -webkit-print-color-adjust: exact;
            color-adjust: exact;
            background: white;
          }
          h2, h3 {
            text-align: center;
            margin-bottom: 12px;
            font-weight: bold;
          }
          .text-center { text-align: center; }
          .font-bold { font-weight: bold; }
          .mr-4 { padding: 0.5rem; }
          .underline { text-decoration: underline; }
          .mt-8 { margin-top: 20px; }
          .mb-6 { margin-bottom: 24px; }
          .village-section { page-break-inside: avoid; margin-bottom: 30px; }
          .location-header {
            display: flex;
            justify-content: center; /* ✅ Added to center the location info */
            gap: 24px;
            font-weight: bold;
            font-size: 16px;
            margin-bottom: 10px;
          }
          table {
            width: 100%;
            border-collapse: collapse;
            font-size: 13px;
            margin-bottom: 15px;
          }
          th, td {
            border: 1px solid #000;
            padding: 6px 8px;
          }
          th {
            background-color: #e5e7eb !important;
            font-weight: bold;
          }
          tr:nth-child(even) {
            background-color: #f9f9f9;
          }
          button, .no-print { display: none !important; }
          thead { display: table-header-group; }
          tfoot { display: table-footer-group; }
        </style>
      </head>
      <body>
        <div class="document-container">
          ${printContent}
        </div>
      </body>
      </html>
    `);
    win.document.close();
    win.print();
  };

  const handleDownloadWord = async () => {
    if (previewUrl) {
      const link = document.createElement("a");
      link.href = previewUrl;
      link.target = "_blank";
      link.download = "अनुसूची-२.doc";
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      return;
    }

    setIsLoading(true);

    // Build Tables dynamically grouped by village with their own Taluka and District
    let dynamicTablesHtml = "";
    Object.entries(groupedByVillage).forEach(([village, items]) => {
      const surveyData = items.filter(item => surveyTypeGroup.includes(item.survey_type));
      const gharData = items.filter(item => item.survey_type === "घर क्रमांक.");

      // Extract specific taluka and district for this village group
      const taluka = items[0]?.tehsil_name || items[0]?.taluka_name || '-';
      const district = items[0]?.dist_name || '-';

      dynamicTablesHtml += `
        <div class="village-section">
          <div style="font-weight: bold;display:flex;justify-content:center; font-size: 14px; margin-bottom: 10px;">
            <span style="margin-right: 10px;">मौजे: ${village}</span>
            <span style="margin-right: 10px;">तालुका: ${taluka}</span>
            <span>जिल्हा: ${district}</span>
          </div>
      `;

      if (surveyData.length > 0) {
        dynamicTablesHtml += `
          <table>
            <thead>
              <tr>
                <th rowspan="2">अ.क्र.</th>
                <th rowspan="2">गट/सर्व्हे क्रमांक</th>
                <th colspan="4">भूसंपादन क्षेत्राच्या चतुःसिमेस असलेले गट/सर्व्हे क्रमांक</th>
              </tr>
              <tr>
                <th>पूर्व</th>
                <th>पश्चिम</th>
                <th>उत्तर</th>
                <th>दक्षिण</th>
              </tr>
            </thead>
            <tbody>
              ${surveyData.map((row, index) => `
                <tr>
                  <td>${index + 1}</td>
                  <td>${row.survey_no || '-'}</td>
                  <td>${row.east || '-'}</td>
                  <td>${row.west || '-'}</td>
                  <td>${row.north || '-'}</td>
                  <td>${row.south || '-'}</td>
                </tr>
              `).join('')}
            </tbody>
          </table>
        `;
      }

      if (gharData.length > 0) {
        dynamicTablesHtml += `
          <table>
            <thead>
              <tr>
                <th rowspan="2">अ.क्र.</th>
                <th rowspan="2">घर क्रमांक</th>
                <th colspan="4">भूसंपादन क्षेत्राच्या चतुःसिमेस असलेले घर क्रमांक</th>
              </tr>
              <tr>
                <th>पूर्व</th>
                <th>पश्चिम</th>
                <th>उत्तर</th>
                <th>दक्षिण</th>
              </tr>
            </thead>
            <tbody>
              ${gharData.map((row, index) => `
                <tr>
                  <td>${index + 1}</td>
                  <td>${row.survey_no || '-'}</td>
                  <td>${row.east || '-'}</td>
                  <td>${row.west || '-'}</td>
                  <td>${row.north || '-'}</td>
                  <td>${row.south || '-'}</td>
                </tr>
              `).join('')}
            </tbody>
          </table>
        `;
      }
      dynamicTablesHtml += `</div>`;
    });

    const htmlContent = `
      <html>
        <head>
          <meta charset="utf-8">
          <style>
            body { font-family: Arial, sans-serif; margin: 20px; }
            table { border-collapse: collapse; width: 100%; margin: 10px 0 20px 0; }
            th, td { border: 1px solid black; padding: 8px; text-align: center; }
            th { background-color: #f0f0f0; font-weight: bold; }
            .header { text-align: center; margin-bottom: 20px; }
            .heading { border-bottom: 2px solid Black; display: inline-block; padding-bottom: 4px; }
            .village-section { margin-bottom: 30px; page-break-inside: avoid; }
          </style>
        </head>
        <body>
          <div class="header">
            <h2>परिशिष्ट-6</h2>
            <div style="margin-bottom: 10px;">
              <span class="right" style="font-weight: bold;">प्रकल्प नाव: ${projectName || '-'} </span>
            </div>
            <h3 class="heading">${parishisht6Header}</h3>
          </div>

          ${dynamicTablesHtml}

          <div style="width: 100%; margin-top: 40px; display: table; table-layout: fixed;">
            <div style="display: table-cell; vertical-align: top; width: 50%; text-align: left;">
              <p style="margin: 2px 0;">दिनांक: ${formattedDate}</p>
              <p style="margin: 2px 0;">ठिकाण: ${InchargeAddress}</p>
            </div>
            <div style="display: table-cell; vertical-align: bottom; width: 25%; text-align: center; padding-top: 60px;">
              <p style="margin: 2px 0;">${regionalInchargeName ? `(${regionalInchargeName})` : ""}</p>
              <p style="margin: 2px 0;">${regionalInchargeDesignation || ""}</p>
            </div>
            <div style="display: table-cell; vertical-align: bottom; width: 25%; text-align: center; padding-top: 60px;">
              <p style="margin: 2px 0;">${InchargeName ? `(${InchargeName})` : ""}</p>
              <p style="margin: 2px 0;">${InchargeDesignation || ""}</p>
            </div>
          </div>
        </body>
      </html>`;

    const blob = new Blob([htmlContent], { type: 'application/vnd.openxmlformats-officedocument.wordprocessingml.document' });
    const url = window.URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.href = url;
    a.download = 'परिशिष्ट 6.doc';
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
    window.URL.revokeObjectURL(url);
    setIsLoading(false);
  };

  const SignatureLoader = ({ text }) => (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-40">
      <div className="bg-white rounded-lg p-6 flex flex-col items-center space-y-4">
        <div className="animate-spin rounded-full h-10 w-10 border-4 border-blue-600 border-t-transparent"></div>
        <p className="text-sm font-medium text-gray-700">{text}</p>
      </div>
    </div>
  );

  return (
    <div className="p-4 border-2">
      <div className="flex justify-between items-center mb-4">
        <div className="flex items-center space-x-3">
          <button onClick={handlePrint} className="flex items-center space-x-2 px-4 py-2 bg-blue-600 text-white rounded-md hover:bg-blue-700">
            <Printer size={18} />
            <span>Print</span>
          </button>
          {/* <button onClick={handleDownloadWord} className="flex items-center space-x-2 px-4 py-2 bg-green-600 text-white rounded-md hover:bg-green-700 disabled:opacity-50">
            <Download size={18} />
            <span>Download Word</span>
          </button> */}
        </div>
      </div>

      {previewUrl ? (
        <div className="w-full bg-white p-4 rounded-lg">
          <iframe
            src={`${previewUrl}#toolbar=0&navpanes=0&scrollbar=0&view=FitH`}
            title="Parishtisht-6 PDF"
            width="100%"
            height="800px"
            style={{ border: "none", borderRadius: "8px" }}
          />
        </div>
      ) : (
        <div ref={documentRef} className="p-6">
          {(isLoading || fetching) ? (
            <div className="flex justify-center items-center h-96">
              <p className="text-lg text-gray-600">Loading...</p>
            </div>
          ) : (
            <>
              <div className="text-center mb-6">
                <h3 className="text-center font-bold mb-2">परिशिष्ट-6 </h3>
                <h3 className="text-center font-bold mb-2">प्रकल्प नाव: {projectName}</h3>

                <div className="my-3">
                  {isEditingParishisht6Header ? (
                    <div className="no-print" style={{ display: "flex", gap: "8px", justifyContent: "center", alignItems: "center", flexWrap: "wrap", marginBottom: "8px" }}>
                      <input
                        type="text"
                        value={parishisht6Header}
                        onChange={(e) => setParishisht6Header(e.target.value)}
                        style={{ width: "60%", border: "1px solid #ccc", padding: "6px 8px", fontSize: "12px", borderRadius: "4px" }}
                      />
                      <button type="button" onClick={handleParishisht6HeaderSave} disabled={parishisht6HeaderSaving} style={{ backgroundColor: "#4CAF50", color: "#fff", border: "none", borderRadius: "4px", padding: "6px 12px", cursor: "pointer", fontSize: "12px" }}>
                        {parishisht6HeaderSaving ? "Saving..." : "Save"}
                      </button>
                      <button type="button" onClick={() => setIsEditingParishisht6Header(false)} style={{ backgroundColor: "#f44336", color: "#fff", border: "none", borderRadius: "4px", padding: "6px 12px", cursor: "pointer", fontSize: "12px" }}>
                        Cancel
                      </button>
                    </div>
                  ) : (
                    <div style={{ display: "flex", gap: "8px", justifyContent: "center", alignItems: "center", flexWrap: "wrap" }}>
                      <h2 className="text-md font-semibold underline m-0">{parishisht6Header}</h2>
                      <button type="button" onClick={() => setIsEditingParishisht6Header(true)} className="no-print" style={{ backgroundColor: "#2196F3", color: "#fff", border: "none", borderRadius: "4px", padding: "4px 10px", cursor: "pointer", fontSize: "12px" }}>
                        <Edit className="h-4 w-4" />
                      </button>
                    </div>
                  )}
                </div>
              </div>

              {/* RENDER DYNAMIC TABLES GROUPED BY VILLAGE */}
              <div className="overflow-x-auto">
                {Object.entries(groupedByVillage).map(([village, items]) => {
                  const surveyData = items.filter(item => surveyTypeGroup.includes(item.survey_type));
                  const gharData = items.filter(item => item.survey_type === "घर क्रमांक.");

                  // Extract specific taluka and district for this village group
                  const taluka = items[0]?.tehsil_name || items[0]?.taluka_name || '-';
                  const district = items[0]?.dist_name || '-';

                  return (
                    <div key={village} className="mb-8 village-section">
                      <div className="location-header flex flex-wrap justify-center gap-x-6 font-bold mb-3 text-md md:text-lg">
                        <span>मौजे: {village}</span>
                        <span>तालुका: {taluka}</span>
                        <span>जिल्हा: {district}</span>
                      </div>

                      {surveyData.length > 0 && (
                        <table className="w-full border-collapse border-2 border-black mb-4">
                          <thead>
                            <tr className="bg-gray-100">
                              <th className="border border-black p-3 font-bold text-center" rowSpan={2}>अ.<br />क्र.</th>
                              <th className="border border-black p-3 font-bold text-center" rowSpan={2}>गट/सर्व्हे क्रमांक</th>
                              <th className="border border-black p-3 font-bold text-center" colSpan={4}>भूसंपादन क्षेत्राच्या चतुःसिमेस असलेले गट/सर्व्हे क्रमांक</th>
                            </tr>
                            <tr className="bg-gray-100">
                              <th className="border border-black p-3 font-bold text-center">पूर्व</th>
                              <th className="border border-black p-3 font-bold text-center">पश्चिम</th>
                              <th className="border border-black p-3 font-bold text-center">उत्तर</th>
                              <th className="border border-black p-3 font-bold text-center">दक्षिण</th>
                            </tr>
                          </thead>
                          <tbody>
                            {surveyData.map((row, index) => (
                              <tr key={index} className={index % 2 === 0 ? 'bg-white' : 'bg-gray-50'}>
                                <td className="border border-black p-2 text-center">{index + 1}</td>
                                <td className="border border-black p-2 text-center">{row.survey_no || '-'}</td>
                                <td className="border border-black p-2 text-center">{row.east || '-'}</td>
                                <td className="border border-black p-2 text-center">{row.west || '-'}</td>
                                <td className="border border-black p-2 text-center">{row.north || '-'}</td>
                                <td className="border border-black p-2 text-center">{row.south || '-'}</td>
                              </tr>
                            ))}
                          </tbody>
                        </table>
                      )}

                      {gharData.length > 0 && (
                        <table className="w-full border-collapse border-2 border-black">
                          <thead>
                            <tr className="bg-gray-100">
                              <th className="border border-black p-3 font-bold text-center" rowSpan={2}>अ.<br />क्र.</th>
                              <th className="border border-black p-3 font-bold text-center" rowSpan={2}>घर क्रमांक</th>
                              <th className="border border-black p-3 font-bold text-center" colSpan={4}>भूसंपादन क्षेत्राच्या चतुःसिमेस असलेले घर क्रमांक</th>
                            </tr>
                            <tr className="bg-gray-100">
                              <th className="border border-black p-3 font-bold text-center">पूर्व</th>
                              <th className="border border-black p-3 font-bold text-center">पश्चिम</th>
                              <th className="border border-black p-3 font-bold text-center">उत्तर</th>
                              <th className="border border-black p-3 font-bold text-center">दक्षिण</th>
                            </tr>
                          </thead>
                          <tbody>
                            {gharData.map((row, index) => (
                              <tr key={index} className={index % 2 === 0 ? 'bg-white' : 'bg-gray-50'}>
                                <td className="border border-black p-2 text-center">{index + 1}</td>
                                <td className="border border-black p-2 text-center">{row.survey_no || '-'}</td>
                                <td className="border border-black p-2 text-center">{row.east || '-'}</td>
                                <td className="border border-black p-2 text-center">{row.west || '-'}</td>
                                <td className="border border-black p-2 text-center">{row.north || '-'}</td>
                                <td className="border border-black p-2 text-center">{row.south || '-'}</td>
                              </tr>
                            ))}
                          </tbody>
                        </table>
                      )}
                    </div>
                  );
                })}
              </div>

              {/* FOOTER SIGNATURE AREA */}
              <div style={{ display: "flex", justifyContent: "space-between", marginTop: "20px" }}>
                <div style={{ textAlign: "left" }}>
                  <p>दिनांक: {formattedDate}</p>
                  <p>ठिकाण: {InchargeAddress}</p>
                </div>
              </div>

              <div style={{ display: "flex", justifyContent: "space-between", marginTop: "40px" }}>
                <div style={{ textAlign: "center", marginTop: "80px", width: "50%" }}>
                  <p> {regionalInchargeName ? ` (${regionalInchargeName})` : ""}</p>
                  <p className='text-center'> {regionalInchargeDesignation ? ` ${regionalInchargeDesignation}` : ""}</p>
                </div>
                <div style={{ textAlign: "center", marginTop: "80px", width: "50%" }}>
                  <p> {InchargeName ? ` (${InchargeName})` : ""}</p>
                  <p className='text-center'> {InchargeDesignation ? ` ${InchargeDesignation}` : ""}</p>
                </div>
              </div>
            </>
          )}
        </div>
      )}

      {showSignaturePad && pdfForSigning && (
        <SignaturePad
          pdfFile={pdfForSigning}
          onSign={(signaturesArray) => {
            setShowSignaturePad(false);
            signDocument(pdfForSigning, signaturesArray);
            setPdfForSigning(null);
          }}
          onCancel={() => {
            setShowSignaturePad(false);
            setPdfForSigning(null);
          }}
        />
      )}

      {isViewerOpen && viewerFile && (
        <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-60">
          <div className="bg-white rounded-lg w-[85%] max-w-6xl h-[85%] relative shadow-xl">
            <div className="flex justify-between items-center px-4 py-3 border-b">
              <h3 className="text-lg font-semibold">Signed Document</h3>
              <button onClick={() => setIsViewerOpen(false)} className="text-xl font-bold hover:text-red-600">✕</button>
            </div>
            <iframe src={viewerFile} title="Signed PDF Viewer" className="w-full h-full" />
          </div>
        </div>
      )}

      {(uploadStatus === "signing" || uploadStatus === "uploading") && (
        <SignatureLoader text={uploadStatus === "signing" ? "Applying digital signature…" : "Uploading signed document…"} />
      )}
    </div>
  );
};

export default Parishtisht6Notice;